var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.item.tipoOblea == 1,
              expression: "item.tipoOblea == 1"
            }
          ],
          attrs: { id: "oblea" }
        },
        [
          _c("div", { attrs: { id: "s1" } }, [
            _c("img", {
              staticStyle: { height: "52px" },
              attrs: { src: _vm.imagenProducto }
            })
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "s2" } }, [
            _c("span", { attrs: { id: "titulo" } }, [
              _vm._v(_vm._s(_vm.nombre))
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "s22" } }, [
            _c("div", [
              _c("span", { staticClass: "label" }, [_vm._v("Precio:")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.moneyLabel) +
                    " " +
                    _vm._s(_vm._f("formatMoney")(_vm.precioComp))
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "label" }, [_vm._v("Subtotal:")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.moneyLabel) +
                    " " +
                    _vm._s(_vm._f("formatMoney")(_vm.subtotalComp))
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "s3" } }, [
            _c("div", { attrs: { id: "cc" } }, [
              _c("span", { attrs: { id: "cantidad" } }, [
                _vm._v("Cantidad: " + _vm._s(_vm.item.Cantidad))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "s4" } })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.item.tipoOblea == 2,
              expression: "item.tipoOblea == 2"
            }
          ],
          attrs: { id: "oblea-desc" }
        },
        [
          _c("div", { attrs: { id: "s1" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "s2" } }, [
            _c("span", { attrs: { id: "titulo" } }, [
              _vm._v(_vm._s(_vm.item.ProductoNombre))
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "s222" } }, [
            _c(
              "span",
              { staticClass: "value", staticStyle: { "margin-left": "60px" } },
              [
                _vm._v(
                  _vm._s(_vm.moneyLabel) +
                    " " +
                    _vm._s(_vm._f("formatMoney")(_vm.item.Precio))
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "s3" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "s4" } })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3caf8d3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3caf8d3e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/estadoPedido/itemPedidoCms.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3caf8d3e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/estadoPedido/itemPedidoCms.vue
// module chunks = 0